import { isApiDomainError } from '@listening/api-contract/errors';
import { Cause, Option } from 'effect';

/**
 * User-facing copy for a failed read or write, or `undefined` to fall back to
 * a generic localized string: a contract domain error's backend-authored
 * `message`. Transport errors (network, decode) and defects return
 * `undefined`.
 */
export const apiFailureMessage = <E>(cause: Cause.Cause<E>) =>
  Cause.findErrorOption(cause).pipe(
    Option.filter(isApiDomainError),
    Option.map((error) => error.message),
    Option.getOrUndefined,
  );
